// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline[data-v-6de2a114]{padding:0}.timeline .timeline__item[data-v-6de2a114]{min-height:50px;padding:0 8px}.timeline .timeline__item .timeline__item__avatar[data-v-6de2a114]{margin-bottom:8px;margin-top:8px;margin-right:8px}.timeline__item__connector[data-v-6de2a114]{position:absolute;left:19px;top:-25px;width:2px;height:100%;background:#ccc}.timeline__item__avatar[data-v-6de2a114]{z-index:1}", ""]);
// Exports
module.exports = exports;
